<template>
  <b-row class="h-100">
    <b-colxx xxs="12" md="10" align="center" class="mx-auto my-auto">
      <b-card class="m-5">
        <h1 class="mt-5">회원님의 아이디는
          <br/>
          "<span style="color:#c11314">{{findID}}</span>"
          <br/>
          입니다.<br/><br/>
          가입일 : {{regDate}}
        </h1>

        <div style="align:center" class="m-3">
            <b-button @click="goLogin" variant="outline-primary">로그인하기</b-button>
            <b-button :to="`forgot-password/${findID}`" variant="primary">비밀번호찾기</b-button>
        </div>
      </b-card>
    </b-colxx>
  </b-row>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";

  export default {
    components: {},
    data() {
      return {
        findID: "aaaaaaaa",
        regDate: this.$moment(new Date()).format('YYYY-MM-DD')
      }
    },
    methods: {
      goLogin(){
        this.$router.push(`/${this.$route.params.sitename}/user/login/${this.findID}`)
      },
    },
  };
</script>
